import React, { useContext, useState, useRef } from 'react'
import axios from 'axios'
import { AuthContext } from '../context/AuthContext'
import { useNavigate } from 'react-router-dom'
import '../styles/SignIn.css'
import config from '../config'
import useResponsiveWidth from '../hooks/useResponsiveWidth'


const SignIn = () => {
  useResponsiveWidth();
  var navigate = useNavigate();
  
  // 12 digits = 6 + 6 for verify
  const [otpCode, setOtpCode] = useState(Array(18).fill(''))
  const otpCodeRefs = useRef([])

  const submitResetPinForm = async (e) => {
    e.preventDefault()
    try {
      const otpTmp = otpCode.join('');
      var otp = otpTmp.slice(0, 6);
      var pin = otpTmp.slice(6, 12);
      var verifyPin = otpTmp.slice(12, 18);
      
      if(otpTmp.length != 18){
        alert('Invalid PIN or OTP. Make sure the PIN is 6 digits and matches the verification PIN.');
        return;
      }

      const response = await axios.post(
        `${config.backendUrl}/api/auth/reset-pin-otp-email`,
        {
          token:localStorage.getItem('vestr_fg_token'),
          pin:pin,
          confirm_pin:verifyPin,
          otp:otp
        }
      )
      if (response.data.status) {
        localStorage.setItem('vestr_fg_token', '');
        alert(response.data.message);
        navigate('/signin');
      }
      else {
        alert(response.data.message);
      }
    } catch (error) {
      console.error(error)
      alert('Error, try again')
    }
  }

  const handleOtpCodeChange = (e, index, rowIndex) => {
    const newOtpCode = [...otpCode]
    const isLastInRow = rowIndex === 1 ? 5 : 17

    if (/^[0-9]$/.test(e.key)) {
      newOtpCode[index] = e.key
      setOtpCode(newOtpCode)

      if (
        index < isLastInRow &&
        otpCodeRefs.current[index + 1].dataset.row === `${rowIndex}`
      ) {
        otpCodeRefs.current[index + 1].focus()
      }
    } else if (e.key === 'Backspace') {
      if (newOtpCode[index]) {
        newOtpCode[index] = ''
      } else if (index > 0) {
        otpCodeRefs.current[index - 1].focus()
        newOtpCode[index - 1] = ''
      }
      setOtpCode(newOtpCode)
    } else if (
      e.key === 'ArrowLeft' &&
      index > 0 &&
      otpCodeRefs.current[index - 1].dataset.row === `${rowIndex}`
    ) {
      otpCodeRefs.current[index - 1].focus()
    } else if (
      e.key === 'ArrowRight' &&
      index < isLastInRow &&
      otpCodeRefs.current[index + 1].dataset.row === `${rowIndex}`
    ) {
      otpCodeRefs.current[index + 1].focus()
    }
    console.log('otpCode: ',otpCode.join(''));
  }

  return (
    <div className="signin-container">
      <h1 className="si-main-header">Invest with the best.</h1>
      <div className="si-main-content">
        <div className="si-intro-text">
          <h2>The Vestr Vision</h2>
          <p style={{ paddingTop: '3rem' }}>
            We envision a <b>finance super app</b> complete with
            leaderboards, live trading, sim trading, feed, news, rooms, copy
            trading, subscriptions, professional research, trading AI and
            more. We want to be the <b>home for the retail revolution</b>,
            where users can find experts and experts find their audience.
          </p>
          <p>
            Also check out{' '}
            <a
              className="si-link bold"
              href="https://vestrdata.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              vestrdata.com
            </a>
            !
          </p>
        </div>
        <div className="si-auth-content">
          <div className="SignNavItems">
            <button className="SignNavButton bold SignNavButtonActive"><span className="si-btn-txt bold">Reset PIN</span></button>
          </div>

          <div className="si-auth-form-wrapper">
            <form className="si-auth-form1 pt-5" onSubmit={submitResetPinForm}>

              <span className="pin-header-label">OTP</span>
              <div className="pin-inputs">
                {Array(6)
                  .fill('')
                  .map((_, index) => (
                    <input
                      key={index}
                      type="text"
                      maxLength="1"
                      className="pin-input"
                      readOnly
                      data-row="1"
                      value={otpCode[index] || ''}
                      onClick={() => otpCodeRefs.current[index].focus()}
                      onKeyDown={(e) => handleOtpCodeChange(e, index, 1)}
                      ref={(el) => (otpCodeRefs.current[index] = el)}
                    />
                  ))}
              </div>
              <span className="pin-header-label">New PIN</span>
              <div className="pin-inputs">
                {Array(6)
                  .fill('')
                  .map((_, index) => (
                    <input
                      key={index}
                      type="text"
                      maxLength="1"
                      className="pin-input"
                      readOnly
                      data-row="2"
                      value={otpCode[index + 6] || ''}
                      onClick={() => otpCodeRefs.current[index + 6].focus()}
                      onKeyDown={(e) => handleOtpCodeChange(e, index + 6, 2)}
                      ref={(el) => (otpCodeRefs.current[index + 6] = el)}
                    />
                  ))}
              </div>

              <span className="pin-header-label">Verify PIN</span>
              <div className="pin-inputs">
                {Array(6)
                  .fill('')
                  .map((_, index) => (
                    <input
                      key={index}
                      type="text"
                      maxLength="1"
                      className="pin-input"
                      readOnly
                      data-row="3"
                      value={otpCode[index + 12] || ''}
                      onClick={() => otpCodeRefs.current[index + 12].focus()}
                      onKeyDown={(e) => handleOtpCodeChange(e, index + 12, 3)}
                      ref={(el) => (otpCodeRefs.current[index + 12] = el)}
                    />
                  ))}
              </div>



              <button type="submit" className="CreatePostFeedButton greenButton moreButtonPadding si-form-btn">Reset</button>
            </form>
          </div>


        </div>
      </div>
    </div>
  )
}

export default SignIn
